import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Service } from "../services/service";
import { BASE_URL } from "../constants/constant";

const service = new Service();

// User Slice
export const initialState = {
  email: "",
  givenName: "",
  familyName: "",
  emailId: "",
  profileImg: "",
  userRoles: null,
  userRoleId: [],
  userRole: [],
  environmentId: [],
  organisationId: "",
  organisationName: "",
  organisation: {},
  bbUserData: {},
  isVFAdmin: false,
  isClientAdmin: false,
  isUser: false,
  currentUser: {},
  loading: false,
  allUsers: [],
  createdUsers: [],
};

// export const getUserLogin = createAsyncThunk("get-user-login", async (obj) => {
//   const url = `${BASE_URL}/api/User/UserLogin`;
//   const params = obj;
//   const user_token = localStorage.getItem("bb_access_token");
//   const bitly_data = await service.testGetApi(url, params, user_token);
//   return bitly_data.data;
// });

export const getUserLogin = createAsyncThunk("get-user-login", async (obj) => {
  const url = `${BASE_URL}/api/User/UserLogin`;
  const params = obj;
  const user_token = localStorage.getItem("bb_access_token");
  const bitly_data = await service.testGetLoginApi(url, params, user_token);
  return bitly_data.data;
});

export const getUserLoginByUserId = createAsyncThunk(
  "get-user-login-by-userId",
  async (obj) => {
    const url = `${BASE_URL}/api/User/UserLoginByUserId`;
    const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const bitly_data = await service.testGetApi(url, params, user_token);
    return bitly_data.data;
  }
);

export const getAllUsers = createAsyncThunk("get-all-users", async (obj) => {
  const url = `${BASE_URL}/api/User/GetAllUsers?organizationId=${obj.organisationId}`;
  const params = {
    searchText: obj.searchText || "",
    organizations: obj.organizations || [],
    access: obj.access || [],
  };
  const user_token = localStorage.getItem("bb_access_token");
  const response = await service.testPostApi(url, params, user_token);
  const data = response.data;
  return data;
});

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateCurrentUser(state, action) {
      state.currentUser = action.payload;
      state.email = action.payload?.data?.email;
      state.givenName = action.payload?.data?.givenName;
      state.familyName = action.payload?.data?.familyName;
    },
    updateBBUser(state, action) {
      state.bbUserData = action.payload;
    },
    updateCreatedUsers(state, action) {
      state.createdUsers = action.payload;
    },
  },
  extraReducers: {
    [getUserLogin.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getUserLogin.fulfilled]: (state, { payload }) => {
      state.currentUser = payload;
      state.userRoleId = payload?.data?.roles?.map((item) => item.roleId);
      state.userRole = payload?.data?.roles?.map((item) => item.roleName);
      state.environmentId = payload?.data?.environments?.map(
        (item) => item?.environmentId
      );
      state.organisationId = payload?.data?.organization?.organizationId;
      state.organisationName = payload?.data?.organization?.organizationName;
      state.organisation = payload?.data?.organization;
      state.email = payload?.data?.email;
      state.givenName = payload?.data?.givenName;
      state.familyName = payload?.data?.familyName;
      state.emailId = payload?.data?.emailId;
      state.loading = false;
    },
    [getUserLogin.rejected]: (state, { payload }) => {
      state.loading = true;
    },
    [getUserLoginByUserId.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getUserLoginByUserId.fulfilled]: (state, { payload }) => {
      state.currentUser = payload;
      state.userRoleId = payload?.data?.roles?.map((item) => item.roleId);
      state.userRole = payload?.data?.roles?.map((item) => item.roleName);
      state.environmentId = payload?.data?.environments?.map(
        (item) => item.environmentId
      );
      state.organisationId = payload?.data?.organization?.organizationId;
      state.email = payload?.data?.email;
      state.givenName = payload?.data?.givenName;
      state.familyName = payload?.data?.familyName;
      state.loading = false;
    },
    [getUserLoginByUserId.rejected]: (state, { payload }) => {
      state.loading = true;
    },
    [getAllUsers.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getAllUsers.fulfilled]: (state, { payload }) => {
      state.allUsers = payload;
      state.loading = false;
    },
    [getAllUsers.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});
export const { updateCurrentUser, updateBBUser, updateCreatedUsers } =
  userSlice.actions;
export default userSlice.reducer;
